import React from 'react'
import createSvgIcon from './../helper'

const fragment = (
  <React.Fragment>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 2517 2517"
      id="vector">
      <g
        id="group"
        transform="translate(164 182)">
        <path
          id="path"
          d="M 1007.5 0 L 1030 0.5 L 1007.5 1 L 1007.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_1"
          d="M 1445.5 0 L 1467 0.5 L 1445.5 1 L 1445.5 0 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_2"
          d="M 996.5 1 L 1001 1.5 L 996.5 2 L 996.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_3"
          d="M 1434.5 1 L 1439 1.5 L 1434.5 2 L 1434.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_4"
          d="M 1471.5 1 L 1474 1.5 L 1471.5 2 L 1471.5 1 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_5"
          d="M 989.5 2 L 992 2.5 L 989.5 3 L 989.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_6"
          d="M 1426.5 2 L 1430 2.5 L 1426.5 3 L 1426.5 2 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_7"
          d="M 1420.5 3 L 1423 3.5 L 1420.5 4 L 1420.5 3 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_8"
          d="M 977.5 4 L 980 4.5 L 977.5 5 L 977.5 4 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_9"
          d="M 1410.5 5 L 1413 5.5 L 1410.5 6 L 1410.5 5 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_10"
          d="M 1502.5 14 L 1503.5 16 L 1502.5 14 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_11"
          d="M 1066.5 15 L 1068.5 18 L 1066.5 15 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_12"
          d="M 1506.5 17 L 1515.5 27 L 1506.5 17 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_13"
          d="M 1358.5 24 L 1357.5 26 L 1358.5 24 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_14"
          d="M 1076.5 25 L 1079.5 29 L 1076.5 25 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_15"
          d="M 1349.5 29 L 1348.5 31 L 1349.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_16"
          d="M 1517.5 29 L 1518.5 31 L 1517.5 29 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_17"
          d="M 1080.5 30 L 1081.5 32 L 1080.5 30 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_18"
          d="M 1344.5 32 L 1343.5 34 L 1344.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_19"
          d="M 1519.5 32 L 1520.5 34 L 1519.5 32 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_20"
          d="M 905.5 33 L 904.5 35 L 905.5 33 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_21"
          d="M 1341.5 34 L 1340.5 36 L 1341.5 34 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_22"
          d="M 1084.5 36 L 1085.5 38 L 1084.5 36 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_23"
          d="M 1335.5 38 L 1334.5 40 L 1335.5 38 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_24"
          d="M 896.5 39 L 895.5 41 L 896.5 39 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_25"
          d="M 1332.5 40 L 1331.5 42 L 1332.5 40 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_26"
          d="M 893.5 41 L 892.5 43 L 893.5 41 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_27"
          d="M 1328.5 43 L 1327.5 45 L 1328.5 43 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_28"
          d="M 889.5 44 L 887.5 47 L 889.5 44 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_29"
          d="M 1324.5 46 L 1322.5 49 L 1324.5 46 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_30"
          d="M 884.5 48 L 882.5 51 L 884.5 48 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_31"
          d="M 1319.5 50 L 1316.5 54 L 1319.5 50 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_32"
          d="M 879.5 52 L 875.5 57 L 879.5 52 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_33"
          d="M 1312.5 56 L 1296.5 73 L 1312.5 56 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_34"
          d="M 1093.5 59 L 1094 61.5 L 1093 61.5 L 1093.5 59 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_35"
          d="M 869.5 61 L 863.5 68 L 869.5 61 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_36"
          d="M 1531.5 62 L 1532 65.5 L 1531 65.5 L 1531.5 62 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_37"
          d="M 1094.5 67 L 1095 79.5 L 1094 79.5 L 1094.5 67 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_38"
          d="M 859.5 72 L 854.5 78 L 859.5 72 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_39"
          d="M 1293.5 76 L 1290.5 80 L 1293.5 76 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_40"
          d="M 852.5 80 L 850.5 83 L 852.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_41"
          d="M 1531.5 80 L 1532 83.5 L 1531 83.5 L 1531.5 80 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_42"
          d="M 1288.5 82 L 1286.5 85 L 1288.5 82 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_43"
          d="M 1093.5 84 L 1094 86.5 L 1093 86.5 L 1093.5 84 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_44"
          d="M 848.5 85 L 847.5 87 L 848.5 85 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_45"
          d="M 1284.5 87 L 1283.5 89 L 1284.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_46"
          d="M 1530.5 87 L 1531 89.5 L 1530 89.5 L 1530.5 87 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_47"
          d="M 845.5 89 L 844.5 91 L 845.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_48"
          d="M 1092.5 89 L 1093 91.5 L 1092 91.5 L 1092.5 89 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_49"
          d="M 1281.5 91 L 1280.5 93 L 1281.5 91 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_50"
          d="M 842.5 93 L 841.5 95 L 842.5 93 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_51"
          d="M 1279.5 94 L 1278.5 96 L 1279.5 94 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_52"
          d="M 840.5 96 L 839.5 98 L 840.5 96 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_53"
          d="M 838.5 99 L 837.5 101 L 838.5 99 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_54"
          d="M 1275.5 100 L 1274.5 102 L 1275.5 100 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_55"
          d="M 1273.5 103 L 1272.5 105 L 1273.5 103 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_56"
          d="M 1270.5 108 L 1269.5 110 L 1270.5 108 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_57"
          d="M 1521.5 111 L 1520.5 113 L 1521.5 111 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_58"
          d="M 1519.5 114 L 1518.5 116 L 1519.5 114 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_59"
          d="M 828.5 116 L 827.5 118 L 828.5 116 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_60"
          d="M 1080.5 116 L 1079.5 118 L 1080.5 116 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_61"
          d="M 1516.5 118 L 1514.5 121 L 1516.5 118 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_62"
          d="M 1077.5 120 L 1069.5 129 L 1077.5 120 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_63"
          d="M 1506.5 128 L 1504.5 131 L 1506.5 128 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_64"
          d="M 1066.5 130 L 1064.5 133 L 1066.5 130 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_65"
          d="M 1501.5 132 L 1500.5 134 L 1501.5 132 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_66"
          d="M 1062.5 133 L 1061.5 135 L 1062.5 133 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_67"
          d="M 1498.5 134 L 1497.5 136 L 1498.5 134 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_68"
          d="M 1030.5 145 L 1033 145.5 L 1030.5 146 L 1030.5 145 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_69"
          d="M 1467.5 145 L 1471 145.5 L 1467.5 146 L 1467.5 145 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_70"
          d="M 1013.5 146 L 1018 146.5 L 1013.5 147 L 1013.5 146 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_71"
          d="M 1450.5 146 L 1456 146.5 L 1450.5 147 L 1450.5 146 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_72"
          d="M 1444.5 147 L 1447 147.5 L 1444.5 148 L 1444.5 147 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_73"
          d="M 987.5 154 L 986.5 156 L 987.5 154 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_74"
          d="M 1421.5 156 L 1420.5 158 L 1421.5 156 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_75"
          d="M 982.5 157 L 981.5 159 L 982.5 157 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_76"
          d="M 1418.5 158 L 1417.5 160 L 1418.5 158 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_77"
          d="M 979.5 159 L 978.5 161 L 979.5 159 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_78"
          d="M 1415.5 160 L 1413.5 163 L 1415.5 160 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_79"
          d="M 975.5 162 L 964.5 174 L 975.5 162 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_80"
          d="M 1409.5 165 L 1405.5 170 L 1409.5 165 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_81"
          d="M 1245.5 170 L 1246 172.5 L 1245 172.5 L 1245.5 170 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_82"
          d="M 807.5 172 L 808 174.5 L 807 174.5 L 807.5 172 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_83"
          d="M 1402.5 173 L 1401.5 175 L 1402.5 173 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_84"
          d="M 963.5 175 L 962.5 177 L 963.5 175 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_85"
          d="M 1244.5 175 L 1245 177.5 L 1244 177.5 L 1244.5 175 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_86"
          d="M 806.5 177 L 807 179.5 L 806 179.5 L 806.5 177 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_87"
          d="M 1399.5 177 L 1398.5 179 L 1399.5 177 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_88"
          d="M 1243.5 180 L 1244 182.5 L 1243 182.5 L 1243.5 180 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_89"
          d="M 805.5 183 L 806 185.5 L 805 185.5 L 805.5 183 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_90"
          d="M 1242.5 186 L 1243 189.5 L 1242 189.5 L 1242.5 186 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_91"
          d="M 804.5 190 L 805 193.5 L 804 193.5 L 804.5 190 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_92"
          d="M 1241.5 194 L 1242 198.5 L 1241 198.5 L 1241.5 194 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_93"
          d="M 803.5 198 L 804 204.5 L 803 204.5 L 803.5 198 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_94"
          d="M 1387.5 204 L 1388 206.5 L 1387 206.5 L 1387.5 204 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_95"
          d="M 1240.5 206 L 1241 291.5 L 1240 291.5 L 1240.5 206 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_96"
          d="M 949.5 207 L 950 209.5 L 949 209.5 L 949.5 207 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_97"
          d="M 1386.5 210 L 1387 216.5 L 1386 216.5 L 1386.5 210 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_98"
          d="M 948.5 215 L 949 291.5 L 948 291.5 L 948.5 215 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_99"
          d="M 339.5 438 L 348 438.5 L 339.5 439 L 339.5 438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_100"
          d="M 665.5 438 L 669 438.5 L 665.5 439 L 665.5 438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_101"
          d="M 948.5 438 L 949 583 L 1240 583 L 1240 438.5 L 1241 438.5 L 1241 582.5 L 1239.5 584 L 949.5 584 L 948 582.5 L 948.5 438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_102"
          d="M 1520.5 438 L 1524 438.5 L 1520.5 439 L 1520.5 438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_103"
          d="M 1841.5 438 L 1850 438.5 L 1841.5 439 L 1841.5 438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_104"
          d="M 328.5 439 L 333 439.5 L 328.5 440 L 328.5 439 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_105"
          d="M 671.5 439 L 674 439.5 L 671.5 440 L 671.5 439 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_106"
          d="M 1515.5 439 L 1518 439.5 L 1515.5 440 L 1515.5 439 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_107"
          d="M 1856.5 439 L 1861 439.5 L 1856.5 440 L 1856.5 439 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_108"
          d="M 319.5 440 L 323 440.5 L 319.5 441 L 319.5 440 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_109"
          d="M 1866.5 440 L 1870 440.5 L 1866.5 441 L 1866.5 440 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_110"
          d="M 312.5 441 L 315 441.5 L 312.5 442 L 312.5 441 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_111"
          d="M 1874.5 441 L 1877 441.5 L 1874.5 442 L 1874.5 441 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_112"
          d="M 305.5 442 L 308 442.5 L 305.5 443 L 305.5 442 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_113"
          d="M 1881.5 442 L 1884 442.5 L 1881.5 443 L 1881.5 442 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_114"
          d="M 294.5 444 L 297 444.5 L 294.5 445 L 294.5 444 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_115"
          d="M 1892.5 444 L 1895 444.5 L 1892.5 445 L 1892.5 444 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_116"
          d="M 289.5 445 L 292 445.5 L 289.5 446 L 289.5 445 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_117"
          d="M 1897.5 445 L 1900 445.5 L 1897.5 446 L 1897.5 445 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_118"
          d="M 280.5 447 L 283 447.5 L 280.5 448 L 280.5 447 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_119"
          d="M 1906.5 447 L 1909 447.5 L 1906.5 448 L 1906.5 447 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_120"
          d="M 702.5 453 L 706.5 458 L 702.5 453 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_121"
          d="M 1486.5 453 L 1482.5 458 L 1486.5 453 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_122"
          d="M 710.5 461 L 714.5 466 L 710.5 461 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_123"
          d="M 1478.5 461 L 1474.5 466 L 1478.5 461 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_124"
          d="M 715.5 467 L 716.5 469 L 715.5 467 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_125"
          d="M 1473.5 467 L 1472.5 469 L 1473.5 467 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_126"
          d="M 719.5 473 L 720.5 475 L 719.5 473 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_127"
          d="M 1469.5 473 L 1468.5 475 L 1469.5 473 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_128"
          d="M 195.5 479 L 194.5 481 L 195.5 479 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_129"
          d="M 1993.5 479 L 1994.5 481 L 1993.5 479 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_130"
          d="M 179.5 488 L 178.5 490 L 179.5 488 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_131"
          d="M 2009.5 488 L 2010.5 490 L 2009.5 488 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_132"
          d="M 174.5 491 L 173.5 493 L 174.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_133"
          d="M 2014.5 491 L 2015.5 493 L 2014.5 491 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_134"
          d="M 171.5 493 L 170.5 495 L 171.5 493 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_135"
          d="M 2017.5 493 L 2018.5 495 L 2017.5 493 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_136"
          d="M 728.5 495 L 729 497.5 L 728 497.5 L 728.5 495 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_137"
          d="M 1460.5 495 L 1461 497.5 L 1460 497.5 L 1460.5 495 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_138"
          d="M 729.5 501 L 730 505.5 L 729 505.5 L 729.5 501 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_139"
          d="M 1459.5 501 L 1460 505.5 L 1459 505.5 L 1459.5 501 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_140"
          d="M 156.5 503 L 155.5 505 L 156.5 503 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_141"
          d="M 2032.5 503 L 2033.5 505 L 2032.5 503 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_142"
          d="M 153.5 505 L 152.5 507 L 153.5 505 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_143"
          d="M 2035.5 505 L 2036.5 507 L 2035.5 505 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_144"
          d="M 149.5 508 L 148.5 510 L 149.5 508 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_145"
          d="M 2039.5 508 L 2040.5 510 L 2039.5 508 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_146"
          d="M 145.5 511 L 144.5 513 L 145.5 511 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_147"
          d="M 2043.5 511 L 2044.5 513 L 2043.5 511 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_148"
          d="M 141.5 514 L 139.5 517 L 141.5 514 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_149"
          d="M 2047.5 514 L 2049.5 517 L 2047.5 514 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_150"
          d="M 729.5 515 L 730 520.5 L 729 520.5 L 729.5 515 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_151"
          d="M 1459.5 515 L 1460 520.5 L 1459 520.5 L 1459.5 515 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_152"
          d="M 136.5 518 L 134.5 521 L 136.5 518 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_153"
          d="M 2052.5 518 L 2054.5 521 L 2052.5 518 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_154"
          d="M 131.5 522 L 128.5 526 L 131.5 522 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_155"
          d="M 2057.5 522 L 2060.5 526 L 2057.5 522 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_156"
          d="M 124.5 528 L 119.5 534 L 124.5 528 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_157"
          d="M 2064.5 528 L 2069.5 534 L 2064.5 528 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_158"
          d="M 113.5 538 L 101.5 551 L 113.5 538 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_159"
          d="M 2075.5 538 L 2087.5 551 L 2075.5 538 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_160"
          d="M 722.5 543 L 721.5 545 L 722.5 543 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_161"
          d="M 1466.5 543 L 1467.5 545 L 1466.5 543 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_162"
          d="M 715.5 554 L 714.5 556 L 715.5 554 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_163"
          d="M 1473.5 554 L 1474.5 556 L 1473.5 554 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_164"
          d="M 96.5 556 L 91.5 562 L 96.5 556 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_165"
          d="M 2092.5 556 L 2097.5 562 L 2092.5 556 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_166"
          d="M 712.5 558 L 704.5 567 L 712.5 558 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_167"
          d="M 1476.5 558 L 1484.5 567 L 1476.5 558 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_168"
          d="M 88.5 565 L 85.5 569 L 88.5 565 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_169"
          d="M 2100.5 565 L 2103.5 569 L 2100.5 565 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_170"
          d="M 701.5 568 L 700.5 570 L 701.5 568 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_171"
          d="M 1487.5 568 L 1488.5 570 L 1487.5 568 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_172"
          d="M 83.5 571 L 80.5 575 L 83.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_173"
          d="M 2105.5 571 L 2108.5 575 L 2105.5 571 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_174"
          d="M 78.5 577 L 77.5 579 L 78.5 577 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_175"
          d="M 2110.5 577 L 2111.5 579 L 2110.5 577 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_176"
          d="M 75.5 581 L 74.5 583 L 75.5 581 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_177"
          d="M 2113.5 581 L 2114.5 583 L 2113.5 581 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_178"
          d="M 669.5 582 L 672 582.5 L 669.5 583 L 669.5 582 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_179"
          d="M 1517.5 582 L 1520 582.5 L 1517.5 583 L 1517.5 582 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_180"
          d="M 361.5 583 L 665 583.5 L 361.5 584 L 361.5 583 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_181"
          d="M 1524.5 583 L 1828 583.5 L 1524.5 584 L 1524.5 583 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_182"
          d="M 344.5 584 L 350 584.5 L 344.5 585 L 344.5 584 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_183"
          d="M 1839.5 584 L 1845 584.5 L 1839.5 585 L 1839.5 584 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_184"
          d="M 72.5 585 L 71.5 587 L 72.5 585 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_185"
          d="M 336.5 585 L 339 585.5 L 336.5 586 L 336.5 585 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_186"
          d="M 1850.5 585 L 1853 585.5 L 1850.5 586 L 1850.5 585 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_187"
          d="M 2116.5 585 L 2117.5 587 L 2116.5 585 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_188"
          d="M 329.5 586 L 332 586.5 L 329.5 587 L 329.5 586 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_189"
          d="M 1857.5 586 L 1860 586.5 L 1857.5 587 L 1857.5 586 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_190"
          d="M 69.5 589 L 68.5 591 L 69.5 589 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_191"
          d="M 2119.5 589 L 2120.5 591 L 2119.5 589 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_192"
          d="M 62.5 599 L 61.5 601 L 62.5 599 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_193"
          d="M 2126.5 599 L 2127.5 601 L 2126.5 599 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_194"
          d="M 60.5 602 L 59.5 604 L 60.5 602 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_195"
          d="M 55.5 610 L 54.5 612 L 55.5 610 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_196"
          d="M 2133.5 610 L 2134.5 612 L 2133.5 610 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_197"
          d="M 248.5 617 L 247.5 619 L 248.5 617 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_198"
          d="M 1940.5 617 L 1941.5 619 L 1940.5 617 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_199"
          d="M 49.5 620 L 48.5 622 L 49.5 620 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_200"
          d="M 2139.5 620 L 2140.5 622 L 2139.5 620 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_201"
          d="M 242.5 621 L 241.5 623 L 242.5 621 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_202"
          d="M 1946.5 621 L 1947.5 623 L 1946.5 621 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_203"
          d="M 239.5 623 L 238.5 625 L 239.5 623 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_204"
          d="M 1949.5 623 L 1950.5 625 L 1949.5 623 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_205"
          d="M 235.5 626 L 234.5 628 L 235.5 626 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_206"
          d="M 1953.5 626 L 1954.5 628 L 1953.5 626 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_207"
          d="M 231.5 629 L 230.5 631 L 231.5 629 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_208"
          d="M 1957.5 629 L 1958.5 631 L 1957.5 629 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_209"
          d="M 227.5 632 L 224.5 636 L 227.5 632 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_210"
          d="M 1961.5 632 L 1964.5 636 L 1961.5 632 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_211"
          d="M 221.5 637 L 212.5 647 L 221.5 637 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_212"
          d="M 1967.5 637 L 1976.5 647 L 1967.5 637 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_213"
          d="M 1979.5 649 L 1988.5 659 L 1979.5 649 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_214"
          d="M 208.5 650 L 200.5 659 L 208.5 650 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_215"
          d="M 198.5 661 L 195.5 665 L 198.5 661 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_216"
          d="M 1990.5 661 L 1993.5 665 L 1990.5 661 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_217"
          d="M 193.5 667 L 191.5 670 L 193.5 667 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_218"
          d="M 1995.5 667 L 1997.5 670 L 1995.5 667 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_219"
          d="M 190.5 671 L 188.5 674 L 190.5 671 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_220"
          d="M 1998.5 671 L 2000.5 674 L 1998.5 671 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_221"
          d="M 187.5 675 L 186.5 677 L 187.5 675 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_222"
          d="M 2001.5 675 L 2002.5 677 L 2001.5 675 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_223"
          d="M 179.5 687 L 178.5 689 L 179.5 687 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_224"
          d="M 2009.5 687 L 2010.5 689 L 2009.5 687 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_225"
          d="M 176.5 692 L 175.5 694 L 176.5 692 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_226"
          d="M 2012.5 692 L 2013.5 694 L 2012.5 692 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_227"
          d="M 8.5 725 L 9 727.5 L 8 727.5 L 8.5 725 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_228"
          d="M 2180.5 725 L 2181 727.5 L 2180 727.5 L 2180.5 725 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_229"
          d="M 949.5 729 L 1239.5 729 L 1241 730.5 L 1240.5 810 L 1240 730 L 949.5 730 L 949 730.5 L 949 809.5 L 948 809.5 L 948 730.5 L 949.5 729 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_230"
          d="M 7.5 730 L 8 732.5 L 7 732.5 L 7.5 730 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_231"
          d="M 2181.5 730 L 2182 732.5 L 2181 732.5 L 2181.5 730 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_232"
          d="M 6.5 735 L 7 737.5 L 6 737.5 L 6.5 735 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_233"
          d="M 2182.5 735 L 2183 737.5 L 2182 737.5 L 2182.5 735 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_234"
          d="M 5.5 741 L 6 743.5 L 5 743.5 L 5.5 741 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_235"
          d="M 2183.5 741 L 2184 743.5 L 2183 743.5 L 2183.5 741 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_236"
          d="M 4.5 747 L 5 750.5 L 4 750.5 L 4.5 747 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_237"
          d="M 2184.5 747 L 2185 750.5 L 2184 750.5 L 2184.5 747 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_238"
          d="M 3.5 754 L 4 757.5 L 3 757.5 L 3.5 754 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_239"
          d="M 2185.5 754 L 2186 757.5 L 2185 757.5 L 2185.5 754 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_240"
          d="M 2.5 763 L 3 767.5 L 2 767.5 L 2.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_241"
          d="M 2186.5 763 L 2187 767.5 L 2186 767.5 L 2186.5 763 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_242"
          d="M 149.5 765 L 150 767.5 L 149 767.5 L 149.5 765 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_243"
          d="M 2039.5 765 L 2040 767.5 L 2039 767.5 L 2039.5 765 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_244"
          d="M 148.5 771 L 149 774.5 L 148 774.5 L 148.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_245"
          d="M 2040.5 771 L 2041 774.5 L 2040 774.5 L 2040.5 771 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_246"
          d="M 1.5 773 L 2 780.5 L 1 780.5 L 1.5 773 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_247"
          d="M 2187.5 773 L 2188 780.5 L 2187 780.5 L 2187.5 773 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_248"
          d="M 147.5 779 L 148 783.5 L 147 783.5 L 147.5 779 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_249"
          d="M 2041.5 779 L 2042 783.5 L 2041 783.5 L 2041.5 779 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_250"
          d="M 146.5 792 L 147 1614.5 L 146 1614.5 L 146.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_251"
          d="M 2042.5 792 L 2043 1614.5 L 2042 1614.5 L 2042.5 792 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_252"
          d="M 0.5 793 L 1 1614.5 L 0 1614.5 L 0.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_253"
          d="M 2188.5 793 L 2189 1613.5 L 2188 1613.5 L 2188.5 793 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_254"
          d="M 803.5 811 L 804 814.5 L 803 814.5 L 803.5 811 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_255"
          d="M 1385.5 811 L 1386 814.5 L 1385 814.5 L 1385.5 811 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_256"
          d="M 947.5 814 L 948 816.5 L 947 816.5 L 947.5 814 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_257"
          d="M 1241.5 814 L 1242 816.5 L 1241 816.5 L 1241.5 814 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_258"
          d="M 804.5 817 L 805 819.5 L 804 819.5 L 804.5 817 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_259"
          d="M 1384.5 817 L 1385 819.5 L 1384 819.5 L 1384.5 817 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_260"
          d="M 939.5 838 L 938.5 840 L 939.5 838 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_261"
          d="M 1249.5 838 L 1250.5 840 L 1249.5 838 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_262"
          d="M 814.5 842 L 815.5 844 L 814.5 842 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_263"
          d="M 1374.5 842 L 1373.5 844 L 1374.5 842 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_264"
          d="M 935.5 844 L 934.5 846 L 935.5 844 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_265"
          d="M 1253.5 844 L 1254.5 846 L 1253.5 844 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_266"
          d="M 816.5 845 L 818.5 848 L 816.5 845 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_267"
          d="M 1372.5 845 L 1370.5 848 L 1372.5 845 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_268"
          d="M 932.5 848 L 929.5 852 L 932.5 848 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_269"
          d="M 1256.5 848 L 1259.5 852 L 1256.5 848 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_270"
          d="M 820.5 850 L 827.5 858 L 820.5 850 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_271"
          d="M 1368.5 850 L 1361.5 858 L 1368.5 850 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_272"
          d="M 924.5 856 L 921.5 860 L 924.5 856 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_273"
          d="M 1264.5 856 L 1267.5 860 L 1264.5 856 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_274"
          d="M 830.5 859 L 832.5 862 L 830.5 859 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_275"
          d="M 1358.5 859 L 1356.5 862 L 1358.5 859 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_276"
          d="M 918.5 861 L 917.5 863 L 918.5 861 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_277"
          d="M 1270.5 861 L 1271.5 863 L 1270.5 861 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_278"
          d="M 834.5 862 L 835.5 864 L 834.5 862 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_279"
          d="M 1354.5 862 L 1353.5 864 L 1354.5 862 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_280"
          d="M 915.5 863 L 914.5 865 L 915.5 863 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_281"
          d="M 1273.5 863 L 1274.5 865 L 1273.5 863 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_282"
          d="M 837.5 864 L 838.5 866 L 837.5 864 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_283"
          d="M 1351.5 864 L 1350.5 866 L 1351.5 864 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_284"
          d="M 910.5 866 L 909.5 868 L 910.5 866 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_285"
          d="M 1278.5 866 L 1279.5 868 L 1278.5 866 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_286"
          d="M 862.5 874 L 866 874.5 L 862.5 875 L 862.5 874 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_287"
          d="M 886.5 874 L 889 874.5 L 886.5 875 L 886.5 874 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_288"
          d="M 1300.5 874 L 1303 874.5 L 1300.5 875 L 1300.5 874 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_289"
          d="M 1323.5 874 L 1327 874.5 L 1323.5 875 L 1323.5 874 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_290"
          d="M 871.5 875 L 881 875.5 L 871.5 876 L 871.5 875 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_291"
          d="M 1308.5 875 L 1318 875.5 L 1308.5 876 L 1308.5 875 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_292"
          d="M 641.5 948 L 673 948.5 L 641.5 949 L 641.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_293"
          d="M 1225.5 948 L 1256 948.5 L 1225.5 949 L 1225.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_294"
          d="M 1808.5 948 L 1832 948.5 L 1808.5 949 L 1808.5 948 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_295"
          d="M 629.5 949 L 634 949.5 L 629.5 950 L 629.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_296"
          d="M 680.5 949 L 685 949.5 L 680.5 950 L 680.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_297"
          d="M 1212.5 949 L 1217 949.5 L 1212.5 950 L 1212.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_298"
          d="M 1263.5 949 L 1269 949.5 L 1263.5 950 L 1263.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_299"
          d="M 1795.5 949 L 1801 949.5 L 1795.5 950 L 1795.5 949 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_300"
          d="M 620.5 950 L 624 950.5 L 620.5 951 L 620.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_301"
          d="M 690.5 950 L 694 950.5 L 690.5 951 L 690.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_302"
          d="M 1204.5 950 L 1208 950.5 L 1204.5 951 L 1204.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_303"
          d="M 1273.5 950 L 1277 950.5 L 1273.5 951 L 1273.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_304"
          d="M 1787.5 950 L 1791 950.5 L 1787.5 951 L 1787.5 950 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_305"
          d="M 614.5 951 L 617 951.5 L 614.5 952 L 614.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_306"
          d="M 697.5 951 L 700 951.5 L 697.5 952 L 697.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_307"
          d="M 1197.5 951 L 1200 951.5 L 1197.5 952 L 1197.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_308"
          d="M 1280.5 951 L 1284 951.5 L 1280.5 952 L 1280.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_309"
          d="M 1780.5 951 L 1784 951.5 L 1780.5 952 L 1780.5 951 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_310"
          d="M 608.5 952 L 611 952.5 L 608.5 953 L 608.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_311"
          d="M 703.5 952 L 706 952.5 L 703.5 953 L 703.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_312"
          d="M 1191.5 952 L 1194 952.5 L 1191.5 953 L 1191.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_313"
          d="M 1775.5 952 L 1778 952.5 L 1775.5 953 L 1775.5 952 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_314"
          d="M 708.5 953 L 711 953.5 L 708.5 954 L 708.5 953 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_315"
          d="M 1186.5 953 L 1189 953.5 L 1186.5 954 L 1186.5 953 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_316"
          d="M 1765.5 954 L 1768 954.5 L 1765.5 955 L 1765.5 954 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_317"
          d="M 717.5 955 L 720 955.5 L 717.5 956 L 717.5 955 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_318"
          d="M 1864.5 960 L 1865.5 962 L 1864.5 960 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_319"
          d="M 1868.5 963 L 1870.5 966 L 1868.5 963 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_320"
          d="M 1873.5 967 L 1877.5 972 L 1873.5 967 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_321"
          d="M 1711.5 974 L 1710.5 976 L 1711.5 974 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_322"
          d="M 1879.5 974 L 1881.5 977 L 1879.5 974 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_323"
          d="M 537.5 978 L 536.5 980 L 537.5 978 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_324"
          d="M 1361.5 979 L 1362.5 981 L 1361.5 979 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_325"
          d="M 1702.5 979 L 1701.5 981 L 1702.5 979 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_326"
          d="M 1883.5 979 L 1884.5 981 L 1883.5 979 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_327"
          d="M 1117.5 980 L 1116.5 982 L 1117.5 980 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_328"
          d="M 532.5 981 L 531.5 983 L 532.5 981 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_329"
          d="M 781.5 981 L 782.5 983 L 781.5 981 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_330"
          d="M 1366.5 982 L 1367.5 984 L 1366.5 982 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_331"
          d="M 1697.5 982 L 1696.5 984 L 1697.5 982 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_332"
          d="M 1112.5 983 L 1111.5 985 L 1112.5 983 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_333"
          d="M 1694.5 984 L 1693.5 986 L 1694.5 984 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_334"
          d="M 1109.5 985 L 1108.5 987 L 1109.5 985 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_335"
          d="M 524.5 986 L 523.5 988 L 524.5 986 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_336"
          d="M 1106.5 987 L 1105.5 989 L 1106.5 987 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_337"
          d="M 521.5 988 L 520.5 990 L 521.5 988 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_338"
          d="M 1688.5 988 L 1687.5 990 L 1688.5 988 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_339"
          d="M 1103.5 989 L 1102.5 991 L 1103.5 989 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_340"
          d="M 1378.5 990 L 1379.5 992 L 1378.5 990 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_341"
          d="M 1685.5 990 L 1684.5 992 L 1685.5 990 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_342"
          d="M 796.5 991 L 797.5 993 L 796.5 991 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_343"
          d="M 1100.5 991 L 1099.5 993 L 1100.5 991 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_344"
          d="M 1381.5 992 L 1382.5 994 L 1381.5 992 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_345"
          d="M 1682.5 992 L 1681.5 994 L 1682.5 992 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_346"
          d="M 514.5 993 L 513.5 995 L 514.5 993 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_347"
          d="M 799.5 993 L 800.5 995 L 799.5 993 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_348"
          d="M 1096.5 994 L 1095.5 996 L 1096.5 994 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_349"
          d="M 1385.5 995 L 1386.5 997 L 1385.5 995 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_350"
          d="M 1678.5 995 L 1677.5 997 L 1678.5 995 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_351"
          d="M 510.5 996 L 509.5 998 L 510.5 996 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_352"
          d="M 803.5 996 L 804.5 998 L 803.5 996 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_353"
          d="M 1092.5 997 L 1091.5 999 L 1092.5 997 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_354"
          d="M 1389.5 998 L 1390.5 1000 L 1389.5 998 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_355"
          d="M 1674.5 998 L 1672.5 1001 L 1674.5 998 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_356"
          d="M 506.5 999 L 505.5 1001 L 506.5 999 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_357"
          d="M 807.5 999 L 809.5 1002 L 807.5 999 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_358"
          d="M 1088.5 1000 L 1086.5 1003 L 1088.5 1000 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_359"
          d="M 1393.5 1001 L 1395.5 1004 L 1393.5 1001 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_360"
          d="M 502.5 1002 L 499.5 1006 L 502.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_361"
          d="M 1669.5 1002 L 1667.5 1005 L 1669.5 1002 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_362"
          d="M 812.5 1003 L 814.5 1006 L 812.5 1003 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_363"
          d="M 1083.5 1004 L 1080.5 1008 L 1083.5 1004 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_364"
          d="M 1398.5 1005 L 1401.5 1009 L 1398.5 1005 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_365"
          d="M 1664.5 1006 L 1661.5 1010 L 1664.5 1006 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_366"
          d="M 496.5 1007 L 493.5 1011 L 496.5 1007 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_367"
          d="M 817.5 1007 L 821.5 1012 L 817.5 1007 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_368"
          d="M 1077.5 1009 L 1073.5 1014 L 1077.5 1009 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_369"
          d="M 1405.5 1011 L 1410.5 1017 L 1405.5 1011 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_370"
          d="M 1657.5 1012 L 1652.5 1018 L 1657.5 1012 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_371"
          d="M 489.5 1013 L 483.5 1020 L 489.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_372"
          d="M 1896.5 1013 L 1897 1028.5 L 1896 1028.5 L 1896.5 1013 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_373"
          d="M 825.5 1014 L 832.5 1022 L 825.5 1014 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_374"
          d="M 1068.5 1017 L 1058.5 1028 L 1068.5 1017 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_375"
          d="M 1415.5 1020 L 1447.5 1053 L 1415.5 1020 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_376"
          d="M 1647.5 1021 L 1612.5 1057 L 1647.5 1021 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_377"
          d="M 477.5 1024 L 441.5 1061 L 477.5 1024 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_378"
          d="M 839.5 1027 L 873.5 1062 L 839.5 1027 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_379"
          d="M 1895.5 1033 L 1896 1035.5 L 1895 1035.5 L 1895.5 1033 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_380"
          d="M 1032.5 1052 L 1020.5 1065 L 1032.5 1052 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_381"
          d="M 1888.5 1055 L 1887.5 1057 L 1888.5 1055 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_382"
          d="M 1455.5 1059 L 1462.5 1067 L 1455.5 1059 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_383"
          d="M 1885.5 1060 L 1884.5 1062 L 1885.5 1060 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_384"
          d="M 1606.5 1061 L 1600.5 1068 L 1606.5 1061 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_385"
          d="M 1883.5 1063 L 1882.5 1065 L 1883.5 1063 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_386"
          d="M 436.5 1064 L 432.5 1069 L 436.5 1064 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_387"
          d="M 878.5 1065 L 882.5 1070 L 878.5 1065 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_388"
          d="M 1016.5 1067 L 1013.5 1071 L 1016.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_389"
          d="M 1880.5 1067 L 1870.5 1078 L 1880.5 1067 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_390"
          d="M 1466.5 1069 L 1468.5 1072 L 1466.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_391"
          d="M 1597.5 1069 L 1594.5 1073 L 1597.5 1069 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_392"
          d="M 428.5 1071 L 426.5 1074 L 428.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_393"
          d="M 885.5 1071 L 887.5 1074 L 885.5 1071 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_394"
          d="M 1010.5 1072 L 1008.5 1075 L 1010.5 1072 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_395"
          d="M 1471.5 1073 L 1473.5 1076 L 1471.5 1073 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_396"
          d="M 1591.5 1074 L 1590.5 1076 L 1591.5 1074 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_397"
          d="M 423.5 1075 L 422.5 1077 L 423.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_398"
          d="M 890.5 1075 L 891.5 1077 L 890.5 1075 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_399"
          d="M 1005.5 1076 L 1004.5 1078 L 1005.5 1076 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_400"
          d="M 420.5 1077 L 419.5 1079 L 420.5 1077 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_401"
          d="M 1587.5 1077 L 1586.5 1079 L 1587.5 1077 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_402"
          d="M 1002.5 1078 L 1001.5 1080 L 1002.5 1078 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_403"
          d="M 1584.5 1079 L 1583.5 1081 L 1584.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_404"
          d="M 1867.5 1079 L 1866.5 1081 L 1867.5 1079 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_405"
          d="M 999.5 1080 L 998.5 1082 L 999.5 1080 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_406"
          d="M 899.5 1081 L 900.5 1083 L 899.5 1081 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_407"
          d="M 1579.5 1082 L 1578.5 1084 L 1579.5 1082 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_408"
          d="M 1486.5 1083 L 1487.5 1085 L 1486.5 1083 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_409"
          d="M 384.5 1092 L 387 1092.5 L 384.5 1093 L 384.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_410"
          d="M 927.5 1092 L 930 1092.5 L 927.5 1093 L 927.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_411"
          d="M 968.5 1092 L 971 1092.5 L 968.5 1093 L 968.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_412"
          d="M 1510.5 1092 L 1513 1092.5 L 1510.5 1093 L 1510.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_413"
          d="M 1551.5 1092 L 1554 1092.5 L 1551.5 1093 L 1551.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_414"
          d="M 1838.5 1092 L 1841 1092.5 L 1838.5 1093 L 1838.5 1092 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_415"
          d="M 376.5 1093 L 381 1093.5 L 376.5 1094 L 376.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_416"
          d="M 933.5 1093 L 938 1093.5 L 933.5 1094 L 933.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_417"
          d="M 960.5 1093 L 964 1093.5 L 960.5 1094 L 960.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_418"
          d="M 1516.5 1093 L 1521 1093.5 L 1516.5 1094 L 1516.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_419"
          d="M 1543.5 1093 L 1548 1093.5 L 1543.5 1094 L 1543.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_420"
          d="M 1832.5 1093 L 1836 1093.5 L 1832.5 1094 L 1832.5 1093 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_421"
          d="M 356.5 1094 L 362 1094.5 L 356.5 1095 L 356.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_422"
          d="M 645.5 1094 L 653 1094.5 L 645.5 1095 L 645.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_423"
          d="M 661.5 1094 L 669 1094.5 L 661.5 1095 L 661.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_424"
          d="M 1228.5 1094 L 1236 1094.5 L 1228.5 1095 L 1228.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_425"
          d="M 1244.5 1094 L 1253 1094.5 L 1244.5 1095 L 1244.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_426"
          d="M 1811.5 1094 L 1820 1094.5 L 1811.5 1095 L 1811.5 1094 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_427"
          d="M 350.5 1095 L 353 1095.5 L 350.5 1096 L 350.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_428"
          d="M 637.5 1095 L 640 1095.5 L 637.5 1096 L 637.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_429"
          d="M 674.5 1095 L 677 1095.5 L 674.5 1096 L 674.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_430"
          d="M 1220.5 1095 L 1224 1095.5 L 1220.5 1096 L 1220.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_431"
          d="M 1257.5 1095 L 1260 1095.5 L 1257.5 1096 L 1257.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_432"
          d="M 1804.5 1095 L 1807 1095.5 L 1804.5 1096 L 1804.5 1095 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_433"
          d="M 679.5 1096 L 682 1096.5 L 679.5 1097 L 679.5 1096 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_434"
          d="M 1196.5 1103 L 1195.5 1105 L 1196.5 1103 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_435"
          d="M 609.5 1105 L 608.5 1107 L 609.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_436"
          d="M 704.5 1105 L 705.5 1107 L 704.5 1105 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_437"
          d="M 1289.5 1106 L 1290.5 1108 L 1289.5 1106 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_438"
          d="M 1189.5 1107 L 1188.5 1109 L 1189.5 1107 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_439"
          d="M 321.5 1108 L 319.5 1111 L 321.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_440"
          d="M 604.5 1108 L 603.5 1110 L 604.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_441"
          d="M 1771.5 1108 L 1770.5 1110 L 1771.5 1108 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_442"
          d="M 1186.5 1109 L 1185.5 1111 L 1186.5 1109 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_443"
          d="M 1295.5 1110 L 1296.5 1112 L 1295.5 1110 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_444"
          d="M 1768.5 1110 L 1767.5 1112 L 1768.5 1110 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_445"
          d="M 600.5 1111 L 599.5 1113 L 600.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_446"
          d="M 713.5 1111 L 714.5 1113 L 713.5 1111 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_447"
          d="M 316.5 1112 L 310.5 1119 L 316.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_448"
          d="M 1182.5 1112 L 1181.5 1114 L 1182.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_449"
          d="M 1298.5 1112 L 1300.5 1115 L 1298.5 1112 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_450"
          d="M 597.5 1113 L 595.5 1116 L 597.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_451"
          d="M 1764.5 1113 L 1763.5 1115 L 1764.5 1113 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_452"
          d="M 717.5 1114 L 718.5 1116 L 717.5 1114 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_453"
          d="M 1178.5 1115 L 1176.5 1118 L 1178.5 1115 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_454"
          d="M 1303.5 1116 L 1305.5 1119 L 1303.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_455"
          d="M 1760.5 1116 L 1757.5 1120 L 1760.5 1116 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_456"
          d="M 592.5 1117 L 589.5 1121 L 592.5 1117 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_457"
          d="M 721.5 1117 L 725.5 1122 L 721.5 1117 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_458"
          d="M 1173.5 1119 L 1169.5 1124 L 1173.5 1119 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_459"
          d="M 308.5 1121 L 306.5 1124 L 308.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_460"
          d="M 1309.5 1121 L 1315.5 1128 L 1309.5 1121 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_461"
          d="M 1753.5 1122 L 1746.5 1130 L 1753.5 1122 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_462"
          d="M 585.5 1123 L 574.5 1135 L 585.5 1123 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_463"
          d="M 729.5 1124 L 746.5 1142 L 729.5 1124 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_464"
          d="M 305.5 1125 L 304.5 1127 L 305.5 1125 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_465"
          d="M 1164.5 1127 L 1129.5 1163 L 1164.5 1127 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_466"
          d="M 303.5 1128 L 302.5 1130 L 303.5 1128 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_467"
          d="M 1322.5 1133 L 1356.5 1168 L 1322.5 1133 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_468"
          d="M 1734.5 1140 L 1705.5 1170 L 1734.5 1140 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_469"
          d="M 293.5 1152 L 294 1154.5 L 293 1154.5 L 293.5 1152 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_470"
          d="M 292.5 1159 L 293 1174.5 L 292 1174.5 L 292.5 1159 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_471"
          d="M 547.5 1160 L 536.5 1172 L 547.5 1160 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_472"
          d="M 768.5 1162 L 778.5 1173 L 768.5 1162 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_473"
          d="M 1122.5 1168 L 1116.5 1175 L 1122.5 1168 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_474"
          d="M 1361.5 1171 L 1366.5 1177 L 1361.5 1171 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_475"
          d="M 1701.5 1172 L 1696.5 1178 L 1701.5 1172 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_476"
          d="M 532.5 1174 L 528.5 1179 L 532.5 1174 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_477"
          d="M 782.5 1175 L 786.5 1180 L 782.5 1175 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_478"
          d="M 1112.5 1177 L 1109.5 1181 L 1112.5 1177 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_479"
          d="M 293.5 1179 L 294 1181.5 L 293 1181.5 L 293.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_480"
          d="M 1370.5 1179 L 1373.5 1183 L 1370.5 1179 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_481"
          d="M 1692.5 1180 L 1690.5 1183 L 1692.5 1180 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_482"
          d="M 524.5 1181 L 522.5 1184 L 524.5 1181 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_483"
          d="M 789.5 1181 L 792.5 1185 L 789.5 1181 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_484"
          d="M 1105.5 1183 L 1103.5 1186 L 1105.5 1183 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_485"
          d="M 1376.5 1184 L 1378.5 1187 L 1376.5 1184 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_486"
          d="M 519.5 1185 L 517.5 1188 L 519.5 1185 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_487"
          d="M 1686.5 1185 L 1684.5 1188 L 1686.5 1185 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_488"
          d="M 795.5 1186 L 797.5 1189 L 795.5 1186 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_489"
          d="M 1100.5 1187 L 1098.5 1190 L 1100.5 1187 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_490"
          d="M 1381.5 1188 L 1383.5 1191 L 1381.5 1188 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_491"
          d="M 1682.5 1188 L 1680.5 1191 L 1682.5 1188 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_492"
          d="M 514.5 1189 L 512.5 1192 L 514.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_493"
          d="M 799.5 1189 L 801.5 1192 L 799.5 1189 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_494"
          d="M 1096.5 1190 L 1094.5 1193 L 1096.5 1190 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_495"
          d="M 1385.5 1191 L 1387.5 1194 L 1385.5 1191 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_496"
          d="M 510.5 1192 L 509.5 1194 L 510.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_497"
          d="M 1677.5 1192 L 1676.5 1194 L 1677.5 1192 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_498"
          d="M 804.5 1193 L 805.5 1195 L 804.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_499"
          d="M 1092.5 1193 L 1091.5 1195 L 1092.5 1193 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_500"
          d="M 1389.5 1194 L 1390.5 1196 L 1389.5 1194 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_501"
          d="M 506.5 1195 L 505.5 1197 L 506.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_502"
          d="M 807.5 1195 L 808.5 1197 L 807.5 1195 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_503"
          d="M 1088.5 1196 L 1087.5 1198 L 1088.5 1196 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_504"
          d="M 503.5 1197 L 502.5 1199 L 503.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_505"
          d="M 1670.5 1197 L 1669.5 1199 L 1670.5 1197 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_506"
          d="M 1085.5 1198 L 1084.5 1200 L 1085.5 1198 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_507"
          d="M 1396.5 1199 L 1397.5 1201 L 1396.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_508"
          d="M 1667.5 1199 L 1666.5 1201 L 1667.5 1199 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_509"
          d="M 1082.5 1200 L 1081.5 1202 L 1082.5 1200 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_510"
          d="M 1399.5 1201 L 1400.5 1203 L 1399.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_511"
          d="M 1664.5 1201 L 1663.5 1203 L 1664.5 1201 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_512"
          d="M 1079.5 1202 L 1078.5 1204 L 1079.5 1202 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_513"
          d="M 494.5 1203 L 493.5 1205 L 494.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_514"
          d="M 1661.5 1203 L 1660.5 1205 L 1661.5 1203 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_515"
          d="M 822.5 1205 L 823.5 1207 L 822.5 1205 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_516"
          d="M 1407.5 1206 L 1408.5 1208 L 1407.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_517"
          d="M 1656.5 1206 L 1655.5 1208 L 1656.5 1206 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_518"
          d="M 1071.5 1207 L 1070.5 1209 L 1071.5 1207 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_519"
          d="M 827.5 1208 L 828.5 1210 L 827.5 1208 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_520"
          d="M 306.5 1210 L 307.5 1212 L 306.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_521"
          d="M 1414.5 1210 L 1415.5 1212 L 1414.5 1210 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_522"
          d="M 309.5 1214 L 317.5 1223 L 309.5 1214 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_523"
          d="M 320.5 1224 L 322.5 1227 L 320.5 1224 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_524"
          d="M 324.5 1227 L 325.5 1229 L 324.5 1227 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_525"
          d="M 1476.5 1234 L 1479 1234.5 L 1476.5 1235 L 1476.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_526"
          d="M 1585.5 1234 L 1588 1234.5 L 1585.5 1235 L 1585.5 1234 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_527"
          d="M 997.5 1235 L 1000 1235.5 L 997.5 1236 L 997.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_528"
          d="M 1481.5 1235 L 1484 1235.5 L 1481.5 1236 L 1481.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_529"
          d="M 1580.5 1235 L 1583 1235.5 L 1580.5 1236 L 1580.5 1235 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_530"
          d="M 408.5 1236 L 411 1236.5 L 408.5 1237 L 408.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_531"
          d="M 903.5 1236 L 906 1236.5 L 903.5 1237 L 903.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_532"
          d="M 991.5 1236 L 994 1236.5 L 991.5 1237 L 991.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_533"
          d="M 1487.5 1236 L 1490 1236.5 L 1487.5 1237 L 1487.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_534"
          d="M 1575.5 1236 L 1578 1236.5 L 1575.5 1237 L 1575.5 1236 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_535"
          d="M 401.5 1237 L 405 1237.5 L 401.5 1238 L 401.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_536"
          d="M 909.5 1237 L 913 1237.5 L 909.5 1238 L 909.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_537"
          d="M 984.5 1237 L 988 1237.5 L 984.5 1238 L 984.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_538"
          d="M 1493.5 1237 L 1496 1237.5 L 1493.5 1238 L 1493.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_539"
          d="M 1568.5 1237 L 1571 1237.5 L 1568.5 1238 L 1568.5 1237 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_540"
          d="M 392.5 1238 L 397 1238.5 L 392.5 1239 L 392.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_541"
          d="M 917.5 1238 L 922 1238.5 L 917.5 1239 L 917.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_542"
          d="M 976.5 1238 L 980 1238.5 L 976.5 1239 L 976.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_543"
          d="M 1500.5 1238 L 1505 1238.5 L 1500.5 1239 L 1500.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_544"
          d="M 1559.5 1238 L 1564 1238.5 L 1559.5 1239 L 1559.5 1238 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_545"
          d="M 354.5 1239 L 358 1239.5 L 354.5 1240 L 354.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_546"
          d="M 378.5 1239 L 387 1239.5 L 378.5 1240 L 378.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_547"
          d="M 927.5 1239 L 936 1239.5 L 927.5 1240 L 927.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_548"
          d="M 962.5 1239 L 970 1239.5 L 962.5 1240 L 962.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_549"
          d="M 1511.5 1239 L 1519 1239.5 L 1511.5 1240 L 1511.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_550"
          d="M 1545.5 1239 L 1553 1239.5 L 1545.5 1240 L 1545.5 1239 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_551"
          d="M 636.5 1313 L 644 1313.5 L 636.5 1314 L 636.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_552"
          d="M 670.5 1313 L 678 1313.5 L 670.5 1314 L 670.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_553"
          d="M 1219.5 1313 L 1227 1313.5 L 1219.5 1314 L 1219.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_554"
          d="M 1253.5 1313 L 1262 1313.5 L 1253.5 1314 L 1253.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_555"
          d="M 1802.5 1313 L 1811 1313.5 L 1802.5 1314 L 1802.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_556"
          d="M 1831.5 1313 L 1835 1313.5 L 1831.5 1314 L 1831.5 1313 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_557"
          d="M 625.5 1314 L 630 1314.5 L 625.5 1315 L 625.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_558"
          d="M 684.5 1314 L 689 1314.5 L 684.5 1315 L 684.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_559"
          d="M 1209.5 1314 L 1213 1314.5 L 1209.5 1315 L 1209.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_560"
          d="M 1267.5 1314 L 1272 1314.5 L 1267.5 1315 L 1267.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_561"
          d="M 1792.5 1314 L 1797 1314.5 L 1792.5 1315 L 1792.5 1314 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_562"
          d="M 618.5 1315 L 621 1315.5 L 618.5 1316 L 618.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_563"
          d="M 693.5 1315 L 696 1315.5 L 693.5 1316 L 693.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_564"
          d="M 1201.5 1315 L 1205 1315.5 L 1201.5 1316 L 1201.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_565"
          d="M 1276.5 1315 L 1280 1315.5 L 1276.5 1316 L 1276.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_566"
          d="M 1784.5 1315 L 1788 1315.5 L 1784.5 1316 L 1784.5 1315 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_567"
          d="M 611.5 1316 L 614 1316.5 L 611.5 1317 L 611.5 1316 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_568"
          d="M 699.5 1316 L 702 1316.5 L 699.5 1317 L 699.5 1316 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_569"
          d="M 1195.5 1316 L 1198 1316.5 L 1195.5 1317 L 1195.5 1316 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_570"
          d="M 1283.5 1316 L 1286 1316.5 L 1283.5 1317 L 1283.5 1316 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_571"
          d="M 1778.5 1316 L 1781 1316.5 L 1778.5 1317 L 1778.5 1316 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_572"
          d="M 606.5 1317 L 609 1317.5 L 606.5 1318 L 606.5 1317 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_573"
          d="M 705.5 1317 L 708 1317.5 L 705.5 1318 L 705.5 1317 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_574"
          d="M 1189.5 1317 L 1192 1317.5 L 1189.5 1318 L 1189.5 1317 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_575"
          d="M 601.5 1318 L 604 1318.5 L 601.5 1319 L 601.5 1318 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_576"
          d="M 710.5 1318 L 713 1318.5 L 710.5 1319 L 710.5 1318 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_577"
          d="M 1863.5 1324 L 1864.5 1326 L 1863.5 1324 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_578"
          d="M 1866.5 1326 L 1868.5 1329 L 1866.5 1326 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_579"
          d="M 1871.5 1330 L 1879.5 1339 L 1871.5 1330 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_580"
          d="M 773.5 1341 L 774.5 1343 L 773.5 1341 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_581"
          d="M 1881.5 1341 L 1882.5 1343 L 1881.5 1341 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_582"
          d="M 1360.5 1343 L 1361.5 1345 L 1360.5 1343 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_583"
          d="M 1118.5 1344 L 1117.5 1346 L 1118.5 1344 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_584"
          d="M 533.5 1345 L 532.5 1347 L 533.5 1345 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_585"
          d="M 780.5 1345 L 781.5 1347 L 780.5 1345 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_586"
          d="M 1365.5 1346 L 1366.5 1348 L 1365.5 1346 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_587"
          d="M 1113.5 1347 L 1112.5 1349 L 1113.5 1347 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_588"
          d="M 1695.5 1348 L 1694.5 1350 L 1695.5 1348 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_589"
          d="M 1110.5 1349 L 1109.5 1351 L 1110.5 1349 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_590"
          d="M 525.5 1350 L 524.5 1352 L 525.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_591"
          d="M 788.5 1350 L 789.5 1352 L 788.5 1350 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_592"
          d="M 1107.5 1351 L 1106.5 1353 L 1107.5 1351 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_593"
          d="M 522.5 1352 L 521.5 1354 L 522.5 1352 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_594"
          d="M 791.5 1352 L 792.5 1354 L 791.5 1352 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_595"
          d="M 1104.5 1353 L 1103.5 1355 L 1104.5 1353 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_596"
          d="M 519.5 1354 L 518.5 1356 L 519.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_597"
          d="M 1686.5 1354 L 1685.5 1356 L 1686.5 1354 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_598"
          d="M 1101.5 1355 L 1100.5 1357 L 1101.5 1355 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_599"
          d="M 1380.5 1356 L 1381.5 1358 L 1380.5 1356 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_600"
          d="M 1683.5 1356 L 1682.5 1358 L 1683.5 1356 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_601"
          d="M 798.5 1357 L 799.5 1359 L 798.5 1357 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_602"
          d="M 1097.5 1358 L 1096.5 1360 L 1097.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_603"
          d="M 1383.5 1358 L 1384.5 1360 L 1383.5 1358 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_604"
          d="M 512.5 1359 L 511.5 1361 L 512.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_605"
          d="M 801.5 1359 L 803.5 1362 L 801.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_606"
          d="M 1679.5 1359 L 1678.5 1361 L 1679.5 1359 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_607"
          d="M 1094.5 1360 L 1092.5 1363 L 1094.5 1360 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_608"
          d="M 1387.5 1361 L 1389.5 1364 L 1387.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_609"
          d="M 1676.5 1361 L 1674.5 1364 L 1676.5 1361 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_610"
          d="M 508.5 1362 L 506.5 1365 L 508.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_611"
          d="M 805.5 1362 L 807.5 1365 L 805.5 1362 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_612"
          d="M 1090.5 1363 L 1088.5 1366 L 1090.5 1363 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_613"
          d="M 1391.5 1364 L 1393.5 1367 L 1391.5 1364 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_614"
          d="M 1671.5 1365 L 1669.5 1368 L 1671.5 1365 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_615"
          d="M 503.5 1366 L 501.5 1369 L 503.5 1366 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_616"
          d="M 810.5 1366 L 812.5 1369 L 810.5 1366 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_617"
          d="M 1085.5 1367 L 1083.5 1370 L 1085.5 1367 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_618"
          d="M 1396.5 1368 L 1399.5 1372 L 1396.5 1368 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_619"
          d="M 1666.5 1369 L 1664.5 1372 L 1666.5 1369 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_620"
          d="M 498.5 1370 L 495.5 1374 L 498.5 1370 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_621"
          d="M 815.5 1370 L 818.5 1374 L 815.5 1370 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_622"
          d="M 1895.5 1371 L 1896 1373.5 L 1895 1373.5 L 1895.5 1371 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_623"
          d="M 1079.5 1372 L 1076.5 1376 L 1079.5 1372 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_624"
          d="M 1402.5 1373 L 1406.5 1378 L 1402.5 1373 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_625"
          d="M 1660.5 1374 L 1656.5 1379 L 1660.5 1374 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_626"
          d="M 492.5 1375 L 487.5 1381 L 492.5 1375 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_627"
          d="M 822.5 1376 L 827.5 1382 L 822.5 1376 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_628"
          d="M 1072.5 1378 L 1066.5 1385 L 1072.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_629"
          d="M 1896.5 1378 L 1897 1393.5 L 1896 1393.5 L 1896.5 1378 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_630"
          d="M 1410.5 1380 L 1419.5 1390 L 1410.5 1380 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_631"
          d="M 1652.5 1381 L 1641.5 1393 L 1652.5 1381 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_632"
          d="M 482.5 1384 L 451.5 1416 L 482.5 1384 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_633"
          d="M 832.5 1385 L 866.5 1420 L 832.5 1385 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_634"
          d="M 1059.5 1390 L 1024.5 1426 L 1059.5 1390 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_635"
          d="M 1895.5 1398 L 1896 1400.5 L 1895 1400.5 L 1895.5 1398 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_636"
          d="M 1431.5 1400 L 1459.5 1429 L 1431.5 1400 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_637"
          d="M 1614.5 1418 L 1603.5 1430 L 1614.5 1418 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_638"
          d="M 442.5 1423 L 435.5 1431 L 442.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_639"
          d="M 1886.5 1423 L 1885.5 1425 L 1886.5 1423 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_640"
          d="M 873.5 1425 L 879.5 1432 L 873.5 1425 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_641"
          d="M 1884.5 1426 L 1883.5 1428 L 1884.5 1426 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_642"
          d="M 1020.5 1428 L 1015.5 1434 L 1020.5 1428 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_643"
          d="M 1882.5 1429 L 1880.5 1432 L 1882.5 1429 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_644"
          d="M 1463.5 1431 L 1466.5 1435 L 1463.5 1431 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_645"
          d="M 1599.5 1432 L 1596.5 1436 L 1599.5 1432 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_646"
          d="M 431.5 1433 L 428.5 1437 L 431.5 1433 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_647"
          d="M 883.5 1434 L 885.5 1437 L 883.5 1434 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_648"
          d="M 1878.5 1434 L 1872.5 1441 L 1878.5 1434 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_649"
          d="M 1012.5 1435 L 1010.5 1438 L 1012.5 1435 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_650"
          d="M 1470.5 1437 L 1471.5 1439 L 1470.5 1437 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_651"
          d="M 1593.5 1437 L 1591.5 1440 L 1593.5 1437 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_652"
          d="M 425.5 1438 L 424.5 1440 L 425.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_653"
          d="M 888.5 1438 L 890.5 1441 L 888.5 1438 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_654"
          d="M 1007.5 1439 L 1006.5 1441 L 1007.5 1439 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_655"
          d="M 1474.5 1440 L 1475.5 1442 L 1474.5 1440 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_656"
          d="M 1589.5 1440 L 1588.5 1442 L 1589.5 1440 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_657"
          d="M 421.5 1441 L 420.5 1443 L 421.5 1441 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_658"
          d="M 892.5 1441 L 893.5 1443 L 892.5 1441 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_659"
          d="M 1003.5 1442 L 1002.5 1444 L 1003.5 1442 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_660"
          d="M 1869.5 1442 L 1867.5 1445 L 1869.5 1442 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_661"
          d="M 418.5 1443 L 417.5 1445 L 418.5 1443 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_662"
          d="M 1585.5 1443 L 1584.5 1445 L 1585.5 1443 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_663"
          d="M 1000.5 1444 L 999.5 1446 L 1000.5 1444 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_664"
          d="M 415.5 1445 L 414.5 1447 L 415.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_665"
          d="M 898.5 1445 L 899.5 1447 L 898.5 1445 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_666"
          d="M 1580.5 1446 L 1579.5 1448 L 1580.5 1446 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_667"
          d="M 993.5 1448 L 992.5 1450 L 993.5 1448 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_668"
          d="M 1507.5 1456 L 1510 1456.5 L 1507.5 1457 L 1507.5 1456 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_669"
          d="M 382.5 1457 L 385 1457.5 L 382.5 1458 L 382.5 1457 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_670"
          d="M 929.5 1457 L 932 1457.5 L 929.5 1458 L 929.5 1457 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_671"
          d="M 965.5 1457 L 969 1457.5 L 965.5 1458 L 965.5 1457 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_672"
          d="M 1512.5 1457 L 1515 1457.5 L 1512.5 1458 L 1512.5 1457 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_673"
          d="M 1549.5 1457 L 1552 1457.5 L 1549.5 1458 L 1549.5 1457 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_674"
          d="M 1836.5 1457 L 1839 1457.5 L 1836.5 1458 L 1836.5 1457 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_675"
          d="M 369.5 1458 L 378 1458.5 L 369.5 1459 L 369.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_676"
          d="M 936.5 1458 L 945 1458.5 L 936.5 1459 L 936.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_677"
          d="M 953.5 1458 L 961 1458.5 L 953.5 1459 L 953.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_678"
          d="M 1520.5 1458 L 1528 1458.5 L 1520.5 1459 L 1520.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_679"
          d="M 1536.5 1458 L 1544 1458.5 L 1536.5 1459 L 1536.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_680"
          d="M 1827.5 1458 L 1833 1458.5 L 1827.5 1459 L 1827.5 1458 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_681"
          d="M 353.5 1459 L 357 1459.5 L 353.5 1460 L 353.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_682"
          d="M 641.5 1459 L 646 1459.5 L 641.5 1460 L 641.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_683"
          d="M 668.5 1459 L 673 1459.5 L 668.5 1460 L 668.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_684"
          d="M 1225.5 1459 L 1229 1459.5 L 1225.5 1460 L 1225.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_685"
          d="M 1251.5 1459 L 1256 1459.5 L 1251.5 1460 L 1251.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_686"
          d="M 1808.5 1459 L 1813 1459.5 L 1808.5 1460 L 1808.5 1459 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_687"
          d="M 348.5 1460 L 351 1460.5 L 348.5 1461 L 348.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_688"
          d="M 635.5 1460 L 638 1460.5 L 635.5 1461 L 635.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_689"
          d="M 676.5 1460 L 679 1460.5 L 676.5 1461 L 676.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_690"
          d="M 1218.5 1460 L 1221 1460.5 L 1218.5 1461 L 1218.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_691"
          d="M 1259.5 1460 L 1262 1460.5 L 1259.5 1461 L 1259.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_692"
          d="M 1802.5 1460 L 1805 1460.5 L 1802.5 1461 L 1802.5 1460 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_693"
          d="M 701.5 1468 L 702.5 1470 L 701.5 1468 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_694"
          d="M 610.5 1469 L 609.5 1471 L 610.5 1469 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_695"
          d="M 1288.5 1470 L 1289.5 1472 L 1288.5 1470 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_696"
          d="M 1190.5 1471 L 1189.5 1473 L 1190.5 1471 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_697"
          d="M 322.5 1472 L 321.5 1474 L 322.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_698"
          d="M 605.5 1472 L 604.5 1474 L 605.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_699"
          d="M 1772.5 1472 L 1771.5 1474 L 1772.5 1472 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_700"
          d="M 1187.5 1473 L 1186.5 1475 L 1187.5 1473 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_701"
          d="M 602.5 1474 L 601.5 1476 L 602.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_702"
          d="M 1769.5 1474 L 1768.5 1476 L 1769.5 1474 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_703"
          d="M 318.5 1475 L 308.5 1486 L 318.5 1475 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_704"
          d="M 1184.5 1475 L 1183.5 1477 L 1184.5 1475 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_705"
          d="M 1297.5 1476 L 1298.5 1478 L 1297.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_706"
          d="M 1766.5 1476 L 1764.5 1479 L 1766.5 1476 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_707"
          d="M 598.5 1477 L 597.5 1479 L 598.5 1477 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_708"
          d="M 715.5 1477 L 717.5 1480 L 715.5 1477 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_709"
          d="M 1180.5 1478 L 1178.5 1481 L 1180.5 1478 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_710"
          d="M 1301.5 1479 L 1303.5 1482 L 1301.5 1479 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_711"
          d="M 1762.5 1479 L 1759.5 1483 L 1762.5 1479 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_712"
          d="M 594.5 1480 L 592.5 1483 L 594.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_713"
          d="M 719.5 1480 L 722.5 1484 L 719.5 1480 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_714"
          d="M 1175.5 1482 L 1172.5 1486 L 1175.5 1482 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_715"
          d="M 1306.5 1483 L 1310.5 1488 L 1306.5 1483 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_716"
          d="M 1756.5 1484 L 1751.5 1490 L 1756.5 1484 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_717"
          d="M 588.5 1485 L 582.5 1492 L 588.5 1485 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_718"
          d="M 726.5 1486 L 732.5 1493 L 726.5 1486 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_719"
          d="M 306.5 1488 L 305.5 1490 L 306.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_720"
          d="M 1168.5 1488 L 1156.5 1501 L 1168.5 1488 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_721"
          d="M 304.5 1491 L 303.5 1493 L 304.5 1491 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_722"
          d="M 1315.5 1491 L 1349.5 1526 L 1315.5 1491 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_723"
          d="M 1746.5 1493 L 1711.5 1529 L 1746.5 1493 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_724"
          d="M 301.5 1496 L 300.5 1498 L 301.5 1496 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_725"
          d="M 576.5 1496 L 541.5 1532 L 576.5 1496 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_726"
          d="M 740.5 1499 L 773.5 1533 L 740.5 1499 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_727"
          d="M 293.5 1517 L 294 1519.5 L 293 1519.5 L 293.5 1517 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_728"
          d="M 292.5 1524 L 293 1539.5 L 292 1539.5 L 292.5 1524 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_729"
          d="M 1130.5 1525 L 1120.5 1536 L 1130.5 1525 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_730"
          d="M 1356.5 1531 L 1363.5 1539 L 1356.5 1531 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_731"
          d="M 1705.5 1533 L 1699.5 1540 L 1705.5 1533 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_732"
          d="M 536.5 1535 L 531.5 1541 L 536.5 1535 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_733"
          d="M 778.5 1536 L 783.5 1542 L 778.5 1536 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_734"
          d="M 1115.5 1539 L 1111.5 1544 L 1115.5 1539 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_735"
          d="M 1367.5 1541 L 1371.5 1546 L 1367.5 1541 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_736"
          d="M 1695.5 1542 L 1692.5 1546 L 1695.5 1542 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_737"
          d="M 527.5 1543 L 524.5 1547 L 527.5 1543 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_738"
          d="M 787.5 1544 L 790.5 1548 L 787.5 1544 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_739"
          d="M 1108.5 1545 L 1105.5 1549 L 1108.5 1545 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_740"
          d="M 1374.5 1547 L 1376.5 1550 L 1374.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_741"
          d="M 1689.5 1547 L 1686.5 1551 L 1689.5 1547 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_742"
          d="M 521.5 1548 L 519.5 1551 L 521.5 1548 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_743"
          d="M 793.5 1549 L 795.5 1552 L 793.5 1549 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_744"
          d="M 1102.5 1550 L 1100.5 1553 L 1102.5 1550 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_745"
          d="M 1379.5 1551 L 1381.5 1554 L 1379.5 1551 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_746"
          d="M 516.5 1552 L 514.5 1555 L 516.5 1552 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_747"
          d="M 1683.5 1552 L 1682.5 1554 L 1683.5 1552 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_748"
          d="M 798.5 1553 L 799.5 1555 L 798.5 1553 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_749"
          d="M 1097.5 1554 L 1096.5 1556 L 1097.5 1554 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_750"
          d="M 1384.5 1555 L 1385.5 1557 L 1384.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_751"
          d="M 1679.5 1555 L 1678.5 1557 L 1679.5 1555 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_752"
          d="M 511.5 1556 L 510.5 1558 L 511.5 1556 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_753"
          d="M 802.5 1556 L 803.5 1558 L 802.5 1556 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_754"
          d="M 1093.5 1557 L 1092.5 1559 L 1093.5 1557 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_755"
          d="M 1388.5 1558 L 1389.5 1560 L 1388.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_756"
          d="M 1675.5 1558 L 1674.5 1560 L 1675.5 1558 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_757"
          d="M 507.5 1559 L 506.5 1561 L 507.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_758"
          d="M 806.5 1559 L 807.5 1561 L 806.5 1559 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_759"
          d="M 1089.5 1560 L 1088.5 1562 L 1089.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_760"
          d="M 1391.5 1560 L 1392.5 1562 L 1391.5 1560 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_761"
          d="M 504.5 1561 L 503.5 1563 L 504.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_762"
          d="M 809.5 1561 L 810.5 1563 L 809.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_763"
          d="M 1671.5 1561 L 1670.5 1563 L 1671.5 1561 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_764"
          d="M 1086.5 1562 L 1085.5 1564 L 1086.5 1562 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_765"
          d="M 501.5 1563 L 500.5 1565 L 501.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_766"
          d="M 1668.5 1563 L 1667.5 1565 L 1668.5 1563 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_767"
          d="M 1083.5 1564 L 1082.5 1566 L 1083.5 1564 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_768"
          d="M 1665.5 1565 L 1664.5 1567 L 1665.5 1565 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_769"
          d="M 1080.5 1566 L 1079.5 1568 L 1080.5 1566 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_770"
          d="M 495.5 1567 L 494.5 1569 L 495.5 1567 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_771"
          d="M 821.5 1569 L 822.5 1571 L 821.5 1569 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_772"
          d="M 1406.5 1570 L 1407.5 1572 L 1406.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_773"
          d="M 1657.5 1570 L 1656.5 1572 L 1657.5 1570 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_774"
          d="M 1072.5 1571 L 1071.5 1573 L 1072.5 1571 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_775"
          d="M 304.5 1572 L 305.5 1574 L 304.5 1572 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_776"
          d="M 487.5 1572 L 486.5 1574 L 487.5 1572 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_777"
          d="M 826.5 1572 L 827.5 1574 L 826.5 1572 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_778"
          d="M 1652.5 1573 L 1651.5 1575 L 1652.5 1573 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_779"
          d="M 307.5 1576 L 309.5 1579 L 307.5 1576 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_780"
          d="M 478.5 1577 L 477.5 1579 L 478.5 1577 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_781"
          d="M 311.5 1581 L 315.5 1586 L 311.5 1581 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_782"
          d="M 318.5 1587 L 320.5 1590 L 318.5 1587 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_783"
          d="M 323.5 1591 L 324.5 1593 L 323.5 1591 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_784"
          d="M 1469.5 1597 L 1472 1597.5 L 1469.5 1598 L 1469.5 1597 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_785"
          d="M 421.5 1598 L 424 1598.5 L 421.5 1599 L 421.5 1598 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_786"
          d="M 1000.5 1599 L 1003 1599.5 L 1000.5 1600 L 1000.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_787"
          d="M 1478.5 1599 L 1481 1599.5 L 1478.5 1600 L 1478.5 1599 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_788"
          d="M 411.5 1600 L 414 1600.5 L 411.5 1601 L 411.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_789"
          d="M 995.5 1600 L 998 1600.5 L 995.5 1601 L 995.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_790"
          d="M 1483.5 1600 L 1486 1600.5 L 1483.5 1601 L 1483.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_791"
          d="M 1578.5 1600 L 1581 1600.5 L 1578.5 1601 L 1578.5 1600 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_792"
          d="M 405.5 1601 L 409 1601.5 L 405.5 1602 L 405.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_793"
          d="M 905.5 1601 L 909 1601.5 L 905.5 1602 L 905.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_794"
          d="M 989.5 1601 L 992 1601.5 L 989.5 1602 L 989.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_795"
          d="M 1489.5 1601 L 1492 1601.5 L 1489.5 1602 L 1489.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_796"
          d="M 1572.5 1601 L 1575 1601.5 L 1572.5 1602 L 1572.5 1601 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_797"
          d="M 398.5 1602 L 402 1602.5 L 398.5 1603 L 398.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_798"
          d="M 912.5 1602 L 916 1602.5 L 912.5 1603 L 912.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_799"
          d="M 981.5 1602 L 985 1602.5 L 981.5 1603 L 981.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_800"
          d="M 1495.5 1602 L 1499 1602.5 L 1495.5 1603 L 1495.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_801"
          d="M 1565.5 1602 L 1569 1602.5 L 1565.5 1603 L 1565.5 1602 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_802"
          d="M 388.5 1603 L 394 1603.5 L 388.5 1604 L 388.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_803"
          d="M 920.5 1603 L 926 1603.5 L 920.5 1604 L 920.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_804"
          d="M 972.5 1603 L 977 1603.5 L 972.5 1604 L 972.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_805"
          d="M 1504.5 1603 L 1509 1603.5 L 1504.5 1604 L 1504.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_806"
          d="M 1555.5 1603 L 1560 1603.5 L 1555.5 1604 L 1555.5 1603 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_807"
          d="M 357.5 1604 L 381 1604.5 L 357.5 1605 L 357.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_808"
          d="M 933.5 1604 L 964 1604.5 L 933.5 1605 L 933.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_809"
          d="M 1517.5 1604 L 1548 1604.5 L 1517.5 1605 L 1517.5 1604 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_810"
          d="M 147.5 1623 L 148 1627.5 L 147 1627.5 L 147.5 1623 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_811"
          d="M 2041.5 1623 L 2042 1627.5 L 2041 1627.5 L 2041.5 1623 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_812"
          d="M 1.5 1626 L 2 1633.5 L 1 1633.5 L 1.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_813"
          d="M 2187.5 1626 L 2188 1633.5 L 2187 1633.5 L 2187.5 1626 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_814"
          d="M 148.5 1632 L 149 1635.5 L 148 1635.5 L 148.5 1632 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_815"
          d="M 2040.5 1632 L 2041 1635.5 L 2040 1635.5 L 2040.5 1632 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_816"
          d="M 2.5 1639 L 3 1643.5 L 2 1643.5 L 2.5 1639 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_817"
          d="M 149.5 1639 L 150 1641.5 L 149 1641.5 L 149.5 1639 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_818"
          d="M 2039.5 1639 L 2040 1641.5 L 2039 1641.5 L 2039.5 1639 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_819"
          d="M 2186.5 1639 L 2187 1643.5 L 2186 1643.5 L 2186.5 1639 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_820"
          d="M 150.5 1645 L 151 1647.5 L 150 1647.5 L 150.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_821"
          d="M 2038.5 1645 L 2039 1647.5 L 2038 1647.5 L 2038.5 1645 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_822"
          d="M 3.5 1649 L 4 1652.5 L 3 1652.5 L 3.5 1649 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_823"
          d="M 2185.5 1649 L 2186 1652.5 L 2185 1652.5 L 2185.5 1649 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_824"
          d="M 152.5 1654 L 153 1656.5 L 152 1656.5 L 152.5 1654 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_825"
          d="M 2036.5 1654 L 2037 1656.5 L 2036 1656.5 L 2036.5 1654 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_826"
          d="M 4.5 1656 L 5 1659.5 L 4 1659.5 L 4.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_827"
          d="M 2184.5 1656 L 2185 1659.5 L 2184 1659.5 L 2184.5 1656 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_828"
          d="M 5.5 1663 L 6 1665.5 L 5 1665.5 L 5.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_829"
          d="M 2183.5 1663 L 2184 1665.5 L 2183 1665.5 L 2183.5 1663 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_830"
          d="M 6.5 1669 L 7 1671.5 L 6 1671.5 L 6.5 1669 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_831"
          d="M 2182.5 1669 L 2183 1671.5 L 2182 1671.5 L 2182.5 1669 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_832"
          d="M 7.5 1674 L 8 1676.5 L 7 1676.5 L 7.5 1674 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_833"
          d="M 2181.5 1674 L 2182 1676.5 L 2181 1676.5 L 2181.5 1674 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_834"
          d="M 8.5 1679 L 9 1681.5 L 8 1681.5 L 8.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_835"
          d="M 2180.5 1679 L 2181 1681.5 L 2180 1681.5 L 2180.5 1679 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_836"
          d="M 170.5 1704 L 171.5 1706 L 170.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_837"
          d="M 2018.5 1704 L 2017.5 1706 L 2018.5 1704 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_838"
          d="M 181.5 1723 L 182.5 1725 L 181.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_839"
          d="M 2007.5 1723 L 2006.5 1725 L 2007.5 1723 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_840"
          d="M 183.5 1726 L 184.5 1728 L 183.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_841"
          d="M 2005.5 1726 L 2004.5 1728 L 2005.5 1726 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_842"
          d="M 188.5 1733 L 189.5 1735 L 188.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_843"
          d="M 2000.5 1733 L 1999.5 1735 L 2000.5 1733 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_844"
          d="M 191.5 1737 L 192.5 1739 L 191.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_845"
          d="M 1997.5 1737 L 1996.5 1739 L 1997.5 1737 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_846"
          d="M 194.5 1741 L 197.5 1745 L 194.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_847"
          d="M 1994.5 1741 L 1991.5 1745 L 1994.5 1741 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_848"
          d="M 199.5 1747 L 205.5 1754 L 199.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_849"
          d="M 1989.5 1747 L 1983.5 1754 L 1989.5 1747 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_850"
          d="M 216.5 1764 L 222.5 1771 L 216.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_851"
          d="M 1972.5 1764 L 1966.5 1771 L 1972.5 1764 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_852"
          d="M 225.5 1772 L 228.5 1776 L 225.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_853"
          d="M 1963.5 1772 L 1960.5 1776 L 1963.5 1772 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_854"
          d="M 231.5 1777 L 232.5 1779 L 231.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_855"
          d="M 1957.5 1777 L 1956.5 1779 L 1957.5 1777 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_856"
          d="M 235.5 1780 L 236.5 1782 L 235.5 1780 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_857"
          d="M 1953.5 1780 L 1952.5 1782 L 1953.5 1780 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_858"
          d="M 242.5 1785 L 243.5 1787 L 242.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_859"
          d="M 1946.5 1785 L 1945.5 1787 L 1946.5 1785 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_860"
          d="M 52.5 1792 L 53.5 1794 L 52.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_861"
          d="M 2136.5 1792 L 2135.5 1794 L 2136.5 1792 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_862"
          d="M 57.5 1800 L 58.5 1802 L 57.5 1800 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_863"
          d="M 2131.5 1800 L 2130.5 1802 L 2131.5 1800 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_864"
          d="M 59.5 1803 L 60.5 1805 L 59.5 1803 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_865"
          d="M 2129.5 1803 L 2128.5 1805 L 2129.5 1803 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_866"
          d="M 61.5 1806 L 62.5 1808 L 61.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_867"
          d="M 2127.5 1806 L 2126.5 1808 L 2127.5 1806 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_868"
          d="M 63.5 1809 L 64.5 1811 L 63.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_869"
          d="M 2125.5 1809 L 2124.5 1811 L 2125.5 1809 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_870"
          d="M 65.5 1812 L 66.5 1814 L 65.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_871"
          d="M 2123.5 1812 L 2122.5 1814 L 2123.5 1812 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_872"
          d="M 68.5 1816 L 69.5 1818 L 68.5 1816 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_873"
          d="M 2120.5 1816 L 2119.5 1818 L 2120.5 1816 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_874"
          d="M 70.5 1819 L 71.5 1821 L 70.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_875"
          d="M 2118.5 1819 L 2117.5 1821 L 2118.5 1819 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_876"
          d="M 328.5 1820 L 331 1820.5 L 328.5 1821 L 328.5 1820 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_877"
          d="M 1858.5 1820 L 1861 1820.5 L 1858.5 1821 L 1858.5 1820 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_878"
          d="M 335.5 1821 L 338 1821.5 L 335.5 1822 L 335.5 1821 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_879"
          d="M 1851.5 1821 L 1854 1821.5 L 1851.5 1822 L 1851.5 1821 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_880"
          d="M 343.5 1822 L 348 1822.5 L 343.5 1823 L 343.5 1822 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_881"
          d="M 1841.5 1822 L 1846 1822.5 L 1841.5 1823 L 1841.5 1822 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_882"
          d="M 73.5 1823 L 74.5 1825 L 73.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_883"
          d="M 356.5 1823 L 1833 1823.5 L 356.5 1824 L 356.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_884"
          d="M 2115.5 1823 L 2114.5 1825 L 2115.5 1823 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_885"
          d="M 76.5 1827 L 78.5 1830 L 76.5 1827 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_886"
          d="M 2112.5 1827 L 2110.5 1830 L 2112.5 1827 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_887"
          d="M 80.5 1832 L 82.5 1835 L 80.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_888"
          d="M 2108.5 1832 L 2106.5 1835 L 2108.5 1832 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_889"
          d="M 84.5 1837 L 87.5 1841 L 84.5 1837 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_890"
          d="M 2104.5 1837 L 2101.5 1841 L 2104.5 1837 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_891"
          d="M 90.5 1844 L 95.5 1850 L 90.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_892"
          d="M 2098.5 1844 L 2093.5 1850 L 2098.5 1844 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_893"
          d="M 99.5 1854 L 115.5 1871 L 99.5 1854 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_894"
          d="M 2089.5 1854 L 2073.5 1871 L 2089.5 1854 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_895"
          d="M 120.5 1874 L 125.5 1880 L 120.5 1874 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_896"
          d="M 2068.5 1874 L 2063.5 1880 L 2068.5 1874 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_897"
          d="M 129.5 1882 L 132.5 1886 L 129.5 1882 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_898"
          d="M 2059.5 1882 L 2056.5 1886 L 2059.5 1882 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_899"
          d="M 135.5 1887 L 137.5 1890 L 135.5 1887 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_900"
          d="M 2053.5 1887 L 2051.5 1890 L 2053.5 1887 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_901"
          d="M 140.5 1891 L 142.5 1894 L 140.5 1891 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_902"
          d="M 2048.5 1891 L 2046.5 1894 L 2048.5 1891 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_903"
          d="M 144.5 1894 L 146.5 1897 L 144.5 1894 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_904"
          d="M 2044.5 1894 L 2042.5 1897 L 2044.5 1894 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_905"
          d="M 149.5 1898 L 150.5 1900 L 149.5 1898 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_906"
          d="M 2039.5 1898 L 2038.5 1900 L 2039.5 1898 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_907"
          d="M 152.5 1900 L 153.5 1902 L 152.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_908"
          d="M 2036.5 1900 L 2035.5 1902 L 2036.5 1900 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_909"
          d="M 156.5 1903 L 157.5 1905 L 156.5 1903 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_910"
          d="M 2032.5 1903 L 2031.5 1905 L 2032.5 1903 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_911"
          d="M 159.5 1905 L 160.5 1907 L 159.5 1905 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_912"
          d="M 2029.5 1905 L 2028.5 1907 L 2029.5 1905 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_913"
          d="M 162.5 1907 L 163.5 1909 L 162.5 1907 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_914"
          d="M 2026.5 1907 L 2025.5 1909 L 2026.5 1907 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_915"
          d="M 165.5 1909 L 166.5 1911 L 165.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_916"
          d="M 2023.5 1909 L 2022.5 1911 L 2023.5 1909 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_917"
          d="M 168.5 1911 L 169.5 1913 L 168.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_918"
          d="M 2020.5 1911 L 2019.5 1913 L 2020.5 1911 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_919"
          d="M 190.5 1924 L 191.5 1926 L 190.5 1924 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_920"
          d="M 1998.5 1924 L 1997.5 1926 L 1998.5 1924 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_921"
          d="M 304.5 1964 L 307 1964.5 L 304.5 1965 L 304.5 1964 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_922"
          d="M 1882.5 1964 L 1885 1964.5 L 1882.5 1965 L 1882.5 1964 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_923"
          d="M 311.5 1965 L 314 1965.5 L 311.5 1966 L 311.5 1965 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_924"
          d="M 1875.5 1965 L 1878 1965.5 L 1875.5 1966 L 1875.5 1965 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_925"
          d="M 318.5 1966 L 322 1966.5 L 318.5 1967 L 318.5 1966 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_926"
          d="M 1867.5 1966 L 1871 1966.5 L 1867.5 1967 L 1867.5 1966 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_927"
          d="M 326.5 1967 L 331 1967.5 L 326.5 1968 L 326.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_928"
          d="M 1858.5 1967 L 1863 1967.5 L 1858.5 1968 L 1858.5 1967 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_929"
          d="M 337.5 1968 L 345 1968.5 L 337.5 1969 L 337.5 1968 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_930"
          d="M 1844.5 1968 L 1852 1968.5 L 1844.5 1969 L 1844.5 1968 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_931"
          d="M 360.5 1969 L 1829 1969.5 L 360.5 1970 L 360.5 1969 Z"
          fill="currentColor"
          fillOpacity="0.6588235"
          stroke="currentColor"
          strokeOpacity="0.6588235"
          strokeWidth="1"/>
        <path
          id="path_932"
          d="M 1001.5 1 L 1033.5 1 L 1045.5 4 Q 1064.1 10.9 1076 24.5 Q 1086.9 36.1 1092 53.5 L 1094 62.5 L 1094 83.5 Q 1088.4 114.4 1067.5 130 Q 1057.6 138.6 1043.5 143 L 1029.5 146 L 1013.5 146 L 996.5 150 Q 976.4 157.9 964 173.5 Q 953 187 949 207.5 Q 950.7 213.8 948 215.5 L 948 292 L 1240.5 292 L 1241 291.5 L 1241 199.5 L 1242 198.5 L 1243 183.5 L 1248 160.5 L 1255 139.5 L 1264 119.5 Q 1284.2 81.2 1315.5 54 Q 1342.9 29.9 1379.5 15 L 1400.5 8 L 1423.5 3 L 1438.5 2 L 1439.5 1 L 1470.5 1 Q 1501.3 7.3 1517 28.5 Q 1524.8 38.3 1529 51.5 L 1532 66.5 L 1532 79.5 L 1531 80.5 L 1530 91.5 L 1522 110.5 L 1507.5 128 Q 1495.4 138.9 1477.5 144 L 1466.5 146 L 1450.5 146 L 1431.5 151 Q 1415.7 157.7 1405 169.5 Q 1396.4 178.9 1391 191.5 L 1386 210.5 L 1386 810.5 L 1384 821.5 L 1377 838.5 Q 1369.9 850.4 1359.5 859 Q 1348.5 868.5 1332.5 873 L 1322.5 875 L 1303.5 875 Q 1275.2 870.3 1260 852.5 Q 1245.2 838.3 1241 813.5 L 1241 730.5 L 1239.5 729 L 949.5 729 L 948 730.5 L 948 813.5 Q 942.9 840.9 925.5 856 Q 913.7 867.7 895.5 873 L 885.5 875 L 866.5 875 Q 835 869.5 819 848.5 L 809 832.5 L 805 821.5 L 803 810.5 L 803 205.5 L 804 204.5 L 805 186.5 L 810 162.5 Q 815.5 142 824 124.5 Q 843.5 85 874.5 57 Q 899.5 34 932.5 19 L 959.5 9 L 985.5 3 L 1000.5 2 L 1001.5 1 Z M 948 438 L 948 583 L 950 584 L 1240 584 L 1241 583 L 1241 438 L 948 438 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_933"
          d="M 348.5 438 L 664.5 438 L 684.5 443 Q 699.7 449.3 710 460.5 Q 720.3 471.2 726 486.5 L 729 498.5 L 730 514.5 L 729 515.5 L 728 528.5 L 723 542.5 Q 715.3 557.8 702.5 568 Q 689.3 579.3 668.5 583 L 361.5 583 L 360.5 584 L 344.5 584 L 343.5 585 L 329.5 586 L 310.5 590 L 288.5 597 L 258.5 611 Q 224.6 630.1 200 658.5 Q 175.9 685.9 161 722.5 L 151 755.5 L 148 771.5 L 148 778.5 L 147 779.5 L 147 791.5 L 146 792.5 L 146 1614.5 L 147 1615.5 L 148 1635.5 L 152 1656.5 L 158 1676.5 L 168 1700.5 Q 188.8 1742.2 222.5 1771 Q 249.6 1794.4 285.5 1809 L 318.5 1819 L 335.5 1822 L 342.5 1822 L 343.5 1823 L 355.5 1823 L 356.5 1824 L 1832.5 1824 L 1833.5 1823 L 1845.5 1823 L 1846.5 1822 L 1853.5 1822 L 1870.5 1819 Q 1892.3 1814.3 1910.5 1806 Q 1958.2 1784.7 1990 1747.5 Q 2013.5 1720.5 2028 1684.5 L 2034 1667.5 L 2039 1647.5 L 2041 1628.5 L 2042 1627.5 L 2042 1615.5 L 2043 1614.5 L 2043 792.5 L 2042 791.5 L 2042 779.5 L 2041 778.5 L 2041 771.5 L 2038 755.5 Q 2033.3 733.7 2025 715.5 Q 2004.1 668.4 1967.5 637 Q 1943.5 616 1912.5 602 L 1885.5 592 L 1859.5 586 L 1845.5 585 L 1844.5 584 L 1828.5 584 L 1827.5 583 L 1520.5 583 Q 1490.5 577 1475 556.5 Q 1465.3 545.2 1461 528.5 L 1459 506.5 L 1460 505.5 L 1461 493.5 L 1465 481.5 Q 1471.2 467.7 1481.5 458 Q 1491.1 448.6 1504.5 443 L 1524.5 438 L 1840.5 438 L 1841.5 439 L 1855.5 439 L 1856.5 440 L 1873.5 441 L 1910.5 448 L 1952.5 461 L 1978.5 472 Q 2045 504 2092 555.5 Q 2129.9 596.1 2155 649.5 L 2167 678.5 L 2175 703.5 L 2183 738.5 L 2185 757.5 L 2186 758.5 L 2186 767.5 L 2187 768.5 L 2187 780.5 L 2188 781.5 L 2188 1625.5 L 2187 1626.5 L 2186 1648.5 L 2185 1649.5 L 2184 1662.5 L 2180 1683.5 L 2173 1710.5 L 2156 1755.5 Q 2123.4 1825.4 2069.5 1874 Q 2023.4 1916.9 1960.5 1943 Q 1933.5 1954 1902.5 1961 L 1874.5 1966 L 1858.5 1967 L 1857.5 1968 L 1844.5 1968 L 1843.5 1969 L 345.5 1969 L 344.5 1968 L 331.5 1968 L 330.5 1967 L 314.5 1966 L 286.5 1961 Q 247.4 1952.1 214.5 1937 Q 144.6 1904.4 96 1850.5 Q 54.9 1806.2 29 1746.5 L 14 1703.5 L 6 1668.5 L 4 1649.5 L 3 1648.5 L 3 1639.5 L 2 1638.5 L 2 1626.5 L 1 1625.5 L 1 781.5 L 2 780.5 L 2 768.5 L 3 767.5 L 3 758.5 L 4 757.5 L 5 744.5 L 11 715.5 Q 19.7 679.7 34 649.5 Q 66.1 581.6 118.5 534 Q 164.3 491.3 226.5 465 L 263.5 452 L 287.5 446 L 315.5 441 L 332.5 440 L 333.5 439 L 347.5 439 L 348.5 438 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_934"
          d="M 634.5 949 L 679.5 949 L 680.5 950 L 696.5 951 L 728.5 958 L 753.5 967 Q 782.3 979.7 805.5 998 Q 842 1027.5 873.5 1062 L 900.5 1083 Q 912 1090 927.5 1093 Q 932.3 1091.8 933.5 1094 L 963.5 1094 L 981.5 1090 L 1004.5 1078 L 1020.5 1065 Q 1051.2 1032.2 1085.5 1003 Q 1109.6 983.1 1139.5 969 L 1165.5 959 L 1200.5 951 L 1216.5 950 L 1217.5 949 L 1262.5 949 L 1263.5 950 L 1272.5 950 L 1273.5 951 L 1286.5 952 L 1308.5 957 Q 1343.4 967.1 1370.5 985 Q 1392.6 999.4 1411.5 1017 L 1462.5 1067 L 1487.5 1085 L 1502.5 1091 L 1516.5 1094 L 1547.5 1094 L 1567.5 1089 L 1586.5 1079 L 1612.5 1057 L 1660.5 1010 Q 1683.7 989.2 1712.5 974 L 1737.5 963 L 1772.5 953 L 1790.5 951 L 1791.5 950 L 1800.5 950 L 1801.5 949 L 1835.5 949 Q 1863.8 954.8 1879 973.5 Q 1888 983.5 1893 997.5 L 1896 1009.5 L 1896 1032.5 Q 1890.2 1063.7 1868.5 1079 Q 1857.8 1087.8 1842.5 1092 L 1831.5 1094 L 1811.5 1094 Q 1810 1096.5 1804.5 1095 Q 1788.3 1097.8 1776.5 1105 L 1753.5 1122 L 1687.5 1185 Q 1662.6 1205.6 1631.5 1220 L 1601.5 1231 L 1574.5 1237 L 1559.5 1238 L 1558.5 1239 L 1545.5 1239 L 1544.5 1240 L 1519.5 1240 L 1518.5 1239 L 1496.5 1238 L 1466.5 1232 Q 1438.9 1224.6 1416.5 1212 Q 1390.8 1197.7 1369.5 1179 L 1309.5 1121 L 1289.5 1106 Q 1276.9 1098.1 1259.5 1095 Q 1254 1096.5 1252.5 1094 L 1228.5 1094 L 1205.5 1099 L 1186.5 1109 L 1164.5 1127 Q 1137.3 1156.8 1106.5 1183 Q 1086.2 1199.7 1062.5 1213 Q 1037.6 1226.6 1006.5 1234 L 983.5 1238 L 976.5 1238 L 975.5 1239 L 936.5 1240 L 935.5 1239 L 922.5 1239 L 921.5 1238 L 906.5 1237 L 879.5 1231 Q 851.8 1223.2 829.5 1210 Q 807.3 1197.2 788.5 1181 L 729.5 1124 L 704.5 1105 Q 692.5 1098 676.5 1095 Q 670.3 1096.8 668.5 1094 L 645.5 1094 L 622.5 1099 Q 608.4 1104.4 597.5 1113 L 525.5 1181 Q 506.7 1197.2 484.5 1210 Q 455.7 1226.7 418.5 1235 L 401.5 1237 L 400.5 1238 L 392.5 1238 L 391.5 1239 L 358.5 1240 L 343.5 1237 L 329.5 1231 Q 317 1223.5 308 1212.5 Q 299.4 1202.1 295 1187.5 L 293 1178.5 L 293 1155.5 Q 299 1126.5 318.5 1111 Q 329.1 1101.6 344.5 1097 L 353.5 1095 L 361.5 1095 L 362.5 1094 L 380.5 1094 Q 381.8 1091.8 386.5 1093 Q 400.8 1090.3 411.5 1084 Q 428.2 1074.2 441.5 1061 L 492.5 1011 L 528.5 984 Q 553.6 967.6 585.5 958 L 605.5 953 L 623.5 951 L 624.5 950 L 633.5 950 L 634.5 949 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
        <path
          id="path_935"
          d="M 644.5 1313 L 669.5 1313 L 670.5 1314 L 683.5 1314 L 684.5 1315 L 692.5 1315 L 693.5 1316 L 704.5 1317 Q 733.1 1322.4 756.5 1333 Q 785.3 1346.2 808.5 1365 L 828.5 1382 L 879.5 1432 L 899.5 1447 Q 912.1 1454.9 929.5 1458 Q 935 1456.5 936.5 1459 L 960.5 1459 L 983.5 1454 L 1002.5 1444 L 1024.5 1426 Q 1051.7 1396.2 1082.5 1370 Q 1102.8 1353.3 1126.5 1340 Q 1151.4 1326.4 1182.5 1319 L 1205.5 1315 L 1212.5 1315 L 1213.5 1314 L 1252.5 1313 L 1253.5 1314 L 1266.5 1314 L 1267.5 1315 L 1282.5 1316 L 1309.5 1322 Q 1337.2 1329.8 1359.5 1343 Q 1381.7 1355.8 1400.5 1372 L 1459.5 1429 L 1481.5 1446 Q 1492.6 1453.4 1507.5 1457 L 1519.5 1458 L 1520.5 1459 L 1543.5 1459 L 1566.5 1454 Q 1580.6 1448.6 1591.5 1440 L 1663.5 1372 Q 1682.3 1355.8 1704.5 1343 Q 1733.3 1326.3 1770.5 1318 L 1787.5 1316 L 1788.5 1315 L 1796.5 1315 L 1797.5 1314 L 1830.5 1313 L 1845.5 1316 L 1859.5 1322 Q 1872 1329.5 1881 1340.5 Q 1889.6 1350.9 1894 1365.5 L 1896 1374.5 L 1896 1397.5 Q 1890 1426.5 1870.5 1442 Q 1859.9 1451.4 1844.5 1456 L 1835.5 1458 L 1827.5 1458 L 1826.5 1459 L 1808.5 1459 Q 1807.2 1461.3 1802.5 1460 Q 1788.2 1462.7 1777.5 1469 L 1756.5 1484 L 1706.5 1533 L 1684.5 1552 Q 1659.5 1572 1628.5 1586 L 1596.5 1597 L 1571.5 1602 L 1555.5 1603 L 1554.5 1604 L 1509.5 1604 L 1508.5 1603 L 1499.5 1603 L 1498.5 1602 L 1486.5 1601 L 1460.5 1595 Q 1428.8 1585.2 1403.5 1569 L 1366.5 1541 L 1315.5 1491 L 1288.5 1470 Q 1277 1463 1261.5 1460 Q 1256.8 1461.3 1255.5 1459 L 1225.5 1459 L 1207.5 1463 L 1184.5 1475 L 1168.5 1488 Q 1137.8 1520.8 1103.5 1550 Q 1079.4 1569.9 1049.5 1584 L 1023.5 1594 L 988.5 1602 L 972.5 1603 L 971.5 1604 L 926.5 1604 L 925.5 1603 L 916.5 1603 L 915.5 1602 L 902.5 1601 L 880.5 1596 Q 845.6 1585.9 818.5 1568 L 786.5 1544 L 719.5 1480 L 701.5 1468 L 686.5 1462 L 672.5 1459 L 641.5 1459 L 621.5 1464 L 602.5 1474 L 576.5 1496 L 528.5 1543 Q 505.3 1563.8 476.5 1579 L 451.5 1590 L 416.5 1600 L 398.5 1602 L 397.5 1603 L 388.5 1603 L 387.5 1604 L 353.5 1604 Q 325.3 1598.3 310 1579.5 Q 300 1568.5 295 1552.5 L 293 1543.5 L 293 1520.5 Q 298.8 1489.3 320.5 1474 Q 331.2 1465.2 346.5 1461 L 357.5 1459 L 377.5 1459 L 378.5 1458 L 389.5 1457 Q 403.7 1453.7 414.5 1447 L 435.5 1431 L 486.5 1381 L 510.5 1361 Q 531.7 1344.7 557.5 1333 Q 576.7 1324.2 599.5 1319 L 621.5 1315 L 643.5 1314 L 644.5 1313 Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1"/>
      </g>
    </svg>

  </React.Fragment>
)

const icon = createSvgIcon(fragment, 'PoolFourth')

export default icon
